import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { trackPageVisit, trackEvent } from '../services/analyticsService';

// Map paths to page names
const getPageName = (path: string): string => {
  const pageNames: Record<string, string> = {
    '/': 'Landing',
    '/pricing': 'Pricing',
    '/contact': 'Contact',
    '/privacy': 'Privacy Policy',
    '/terms': 'Terms of Service',
    '/become-investor': 'Become Investor',
    '/login': 'Login',
    '/app': 'Hub',
    '/app/speech': 'Pronunciation Practice',
    '/app/interview': 'Interview Practice',
    '/app/ielts': 'IELTS Hub',
    '/app/ielts/speaking': 'IELTS Speaking',
    '/app/ielts/listening': 'IELTS Listening',
    '/app/ielts/writing': 'IELTS Writing',
    '/app/ielts/reading': 'IELTS Reading',
    '/app/profile': 'Profile',
    '/admin': 'Admin',
    '/investor': 'Investor Dashboard',
    '/payment/success': 'Payment Success',
    '/payment/cancel': 'Payment Cancel',
  };

  return pageNames[path] || path;
};

export const usePageTracking = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    // Don't track if same path (prevents double tracking)
    if (previousPath.current === location.pathname) {
      return;
    }

    previousPath.current = location.pathname;

    const pageName = getPageName(location.pathname);

    trackPageVisit(
      pageName,
      location.pathname,
      currentUser?.uid,
      currentUser?.email || undefined
    );
  }, [location.pathname, currentUser]);
};

export const useEventTracking = () => {
  const { currentUser } = useAuth();

  const track = (eventType: string, eventData: Record<string, any> = {}) => {
    trackEvent(
      eventType,
      eventData,
      currentUser?.uid,
      currentUser?.email || undefined
    );
  };

  return { track };
};

export default usePageTracking;
